<template>
  <div v-if="value.meta">
    <el-divider>Playing Details / თამაშის დეტალები</el-divider>

    <!-- Personal ID Field -->
    <el-row :gutter="60">
      <el-col :span="24" :md="8" class="mt-10">
        <el-input-title required>Personal ID / პირადი ნომერი</el-input-title>
        <el-form-item prop="meta.personalId">
          <el-input
            class="mt-05"
            v-model="value.meta.personalId"
            placeholder="Enter Personal ID"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="60">
      <!-- Club -->
      <el-col :span="24" :md="8" class="mt-10">
        <el-input-title required>Club / კლუბი</el-input-title>
        <el-form-item prop="meta.club">
          <el-select
            class="mt-05 w-100"
            v-model="value.meta.club"
            placeholder="Select Club"
            filterable
          >
            <el-option
              v-for="club in clubOptions"
              :key="club.value"
              :label="club.label"
              :value="club.value"
            />
          </el-select>
        </el-form-item>
      </el-col>

      <!-- Primary Position -->
      <el-col :span="24" :md="8" class="mt-10">
        <el-input-title>Primary Position / ძირითადი პოზიცია</el-input-title>
        <el-form-item prop="meta.primaryPosition">
          <el-select
            class="mt-05 w-100"
            v-model="value.meta.primaryPosition"
            placeholder="Select Position"
          >
            <el-option
              v-for="position in positionOptions"
              :key="position.value"
              :label="position.label"
              :value="position.value"
            />
          </el-select>
        </el-form-item>
      </el-col>

      <!-- Other Positions -->
      <el-col :span="24" :md="8" class="mt-10">
        <el-input-title>Other Positions / სხვა პოზიციები</el-input-title>
        <el-form-item prop="meta.otherPositions">
          <el-select
            class="mt-05 w-100"
            v-model="value.meta.otherPositions"
            placeholder="Select Positions"
            multiple
          >
            <el-option
              v-for="position in positionOptions"
              :key="position.value"
              :label="position.label"
              :value="position.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="60">
      <!-- League -->
      <el-col :span="24" :md="8" class="mt-10">
        <el-input-title>League / ლიგა</el-input-title>
        <el-form-item prop="meta.league">
          <el-select
            class="mt-05 w-100"
            v-model="value.meta.league"
            placeholder="Select League"
          >
            <el-option
              v-for="league in leagueOptions"
              :key="league.value"
              :label="league.label"
              :value="league.value"
            />
          </el-select>
        </el-form-item>
      </el-col>

      <!-- Height -->
      <el-col :span="24" :md="8" class="mt-10">
        <el-input-title>Height (cm) / სიმაღლე</el-input-title>
        <el-form-item prop="meta.height">
          <el-input
            class="mt-05"
            v-model.number="value.meta.height"
            placeholder="Enter height in cm"
            type="number"
          />
        </el-form-item>
      </el-col>

      <!-- Black Lion Member -->
      <el-col :span="24" :md="8" class="mt-10">
        <el-input-title>Black Lion Member / შავი ლომის წევრი</el-input-title>
        <el-form-item prop="meta.blackLionMember">
          <el-input
            v-model="value.meta.blackLionMember"
            placeholder="Select / აირჩიეთ"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="60">
      <!-- Season -->
      <el-col :span="24" :md="8" class="mt-10">
        <el-input-title>Season / სეზონი</el-input-title>
        <el-form-item prop="meta.season">
          <el-select
            class="mt-05 w-100"
            v-model="value.meta.season"
            placeholder="Select Season"
          >
            <el-option value="2025-26" label="2025-26" />
            <el-option value="2024-25" label="2024-25" />
            <el-option value="2023-24" label="2023-24" />
          </el-select>
        </el-form-item>
      </el-col>

      <!-- Previous Season -->
      <el-col :span="24" :md="8" class="mt-10">
        <el-input-title>Previous Season / წინა სეზონი</el-input-title>
        <el-form-item prop="meta.previousSeason">
          <el-select
            class="mt-05 w-100"
            v-model="value.meta.previousSeason"
            placeholder="Select Previous Season"
          >
            <el-option value="2024-25" label="2024-25" />
            <el-option value="2023-24" label="2023-24" />
            <el-option value="2022-23" label="2022-23" />
          </el-select>
        </el-form-item>
      </el-col>

      <!-- Previous Club -->
      <el-col :span="24" :md="8" class="mt-10">
        <el-input-title>Previous Club / წინა კლუბი</el-input-title>
        <el-form-item prop="meta.previousClub">
          <el-select
            class="mt-05 w-100"
            v-model="value.meta.previousClub"
            placeholder="Select Previous Club"
          >
            <el-option
              v-for="option in previousClubOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="60">
      <!-- Transfer Type -->
      <el-col :span="24" :md="8" class="mt-10">
        <el-input-title>Transfer Type / ტრანსფერის ტიპი</el-input-title>
        <el-form-item prop="meta.transferType">
          <el-select
            class="mt-05 w-100"
            v-model="value.meta.transferType"
            placeholder="Select Transfer Type"
          >
            <el-option
              v-for="option in transferTypeOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </el-form-item>
      </el-col>

      <!-- Compensation -->
      <el-col :span="24" :md="8" class="mt-10">
        <el-input-title>Compensation / კომპენსაცია</el-input-title>
        <el-form-item prop="meta.compensation">
          <el-select
            class="mt-05 w-100"
            v-model="value.meta.compensation"
            placeholder="Select"
          >
            <el-option
              v-for="option in yesNoOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="60">
      <!-- Contract Start Date -->
      <el-col :span="24" :md="8" class="mt-10">
        <el-input-title>Contract Start Date / კონტრაქტის დაწყების თარიღი</el-input-title>
        <el-form-item prop="meta.contractStartDate">
          <el-date-picker
            class="mt-05 w-100"
            v-model="value.meta.contractStartDate"
            placeholder="Select Date"
            value-format="timestamp"
            format="dd/MM/yyyy"
          />
        </el-form-item>
      </el-col>

      <!-- Contract End Date -->
      <el-col :span="24" :md="8" class="mt-10">
        <el-input-title>Contract End Date / კონტრაქტის დასრულების თარიღი</el-input-title>
        <el-form-item prop="meta.contractEndDate">
          <el-date-picker
            class="mt-05 w-100"
            v-model="value.meta.contractEndDate"
            placeholder="Select Date"
            value-format="timestamp"
            format="dd/MM/yyyy"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <!-- Comment -->
    <el-row :gutter="60">
      <el-col :span="24" class="mt-10">
        <el-input-title>Comment / კომენტარი</el-input-title>
        <el-form-item prop="meta.comment">
          <el-input
            class="mt-05"
            type="textarea"
            :rows="3"
            v-model="value.meta.comment"
            placeholder="Enter comments..."
          />
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import playerDetails from '@/mixins/player-details';

export default {
  name: 'GeorgiaExtras',
  mixins: [playerDetails],
  props: ['value', 'refs'],
  data() {
    return {
      clubOptions: [
        { value: 'aia', label: 'აია / Aia' },
        { value: 'aresi', label: 'არესი / Aresi' },
        { value: 'armia', label: 'არმია / Armia' },
        { value: 'batumi', label: 'ბათუმი / Batumi' },
        { value: 'lelo', label: 'ლელო / Lelo Saracens' },
        { value: 'tsikara', label: 'წიქარა / Tsikara' },
        { value: 'kazbegi', label: 'ყაზბეგი / Kazbegi' },
        { value: 'gori', label: 'გორის ჯიქი / Gori' },
        { value: 'kharebi', label: 'ხარები / Kharebi' },
        { value: 'khvamli', label: 'ხვამლი / Khvamli' },
        { value: 'shavi_bastionebi', label: 'შავი ბასტიონები / Shavi Bastionebi' },
        { value: 'kochebi', label: 'ყოჩები / Kochebi' },
        { value: 'tao', label: 'ტაო / Tao' },
        { value: 'armazi', label: 'არმაზი / Armazi' },
        { value: 'chadari', label: 'ჭადარი / Chadari' },
        { value: 'dinozavri', label: 'დინოზავრი წყალტუბო / Dinozavri' },
        { value: 'vepkhvebi', label: 'ვეფხვები / Vepkhvebi' },
        { value: 'poti', label: 'ფოთი / Poti' },
        { value: 'lokomotivi', label: 'ლოკომოტივი / Lokomotivi' },
        { value: 'mate', label: 'მათე / Mate' },
        { value: 'artsivebi', label: 'არწივები / Artsivebi' },
        { value: 'aieti', label: 'აიეტი / Aieti' },
        { value: 'zugdidi', label: 'ზუგდიდი / Zugdidi' },
        { value: 'kolkhi_meomrebi', label: 'კოლხი მეომრები / Kolkhi Meomrebi' },
        { value: 'bagrati', label: 'ბაგრატი / Bagrati' },
        { value: 'kvemo_kartli', label: 'ქვემო ქართლი / Kvemo kartli' },
        { value: 'jari', label: 'ჯარი / Jari' },
        { value: 'sokhumi', label: 'სოხუმი / Sokhumi' },
        { value: 'patardzeuli', label: 'პატარძეული / Patardzeuli' },
        { value: 'devebi', label: 'დევები / Devebi' },
        { value: 'gardasakhva', label: 'გარდასახვა / Gardasakhva' },
        { value: 'lashari', label: 'ლაშარი / Lashari' },
        { value: 'aragvelebi', label: 'არაგველები / Aragvelebi' }
      ],
      positionOptions: [
        { value: '1', label: '1 - Loosehead Prop' },
        { value: '2', label: '2 - Hooker' },
        { value: '3', label: '3 - Tighthead Prop' },
        { value: '4', label: '4 - Lock' },
        { value: '5', label: '5 - Lock' },
        { value: '6', label: '6 - Blindside Flanker' },
        { value: '7', label: '7 - Openside Flanker' },
        { value: '8', label: '8 - Number 8' },
        { value: '9', label: '9 - Scrum-half' },
        { value: '10', label: '10 - Fly-half' },
        { value: '11', label: '11 - Left Wing' },
        { value: '12', label: '12 - Inside Centre' },
        { value: '13', label: '13 - Outside Centre' },
        { value: '14', label: '14 - Right Wing' },
        { value: '15', label: '15 - Fullback' },
      ],
      leagueOptions: [
        { value: 'didi_10', label: 'დიდი 10 / Didi 10' },
        { value: 'first_league', label: 'პირველი ლიგა / First League' },
        { value: 'regional_league', label: 'რეგიონალური ლიგა / Regional League' },
      ],
      yesNoOptions: [
        { value: 'yes', label: 'კი / Yes' },
        { value: 'no', label: 'არა / No' },
      ],
      previousClubOptions: [
        { value: 'same', label: 'იგივე / Same' },
        { value: 'never_played', label: 'არასდროს უთამაშია / Never Played' },
        { value: 'defunct_club', label: 'გაუქმებული კლუბი / Defunct Club' },
        { value: 'other', label: 'სხვა / Other' },
      ],
      transferTypeOptions: [
        { value: 'loan_professional', label: 'განათხოვრება (მხოლოდ პროფესიონალის) / Loan (professional only)' },
        { value: 'club_to_club', label: 'ტრანსფერი კლუბიდან კლუბში / Club to club' },
      ],
    };
  },
  mounted() {
    // Set default values for Georgia
    if (!this.value.meta.season) {
      this.$set(this.value.meta, 'season', '2025-26');
    }

    // Initialize arrays if they don't exist
    if (!this.value.meta.otherPositions) {
      this.$set(this.value.meta, 'otherPositions', []);
    }

    // Ensure all other meta fields exist
    const defaultMetaFields = {
      personalId: '',
      club: '',
      primaryPosition: '',
      league: '',
      height: null,
      blackLionMember: '',
      previousSeason: '',
      previousClub: '',
      transferType: '',
      compensation: '',
      contractStartDate: null,
      contractEndDate: null,
      comment: ''
    };

    Object.keys(defaultMetaFields).forEach((field) => {
      if (this.value.meta[field] === undefined) {
        this.$set(this.value.meta, field, defaultMetaFields[field]);
      }
    });

    // Set default nationality to Georgia if not set
    if (!this.value.profile.nationality) {
      this.$set(this.value.profile, 'nationality', 'georgia');
    }

    // Set default country to Georgia if address exists and country not set
    if (this.value.profile.address && !this.value.profile.address.country) {
      this.$set(this.value.profile.address, 'country', 'georgia');
    }
  },
  methods: {
    // Add any Georgian-specific validation or methods here
  }
};
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}

.el-date-editor {
  width: 100%;
}

.w-100 {
  width: 100%;
}
</style>
